import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[inputSuffix]' // tslint:disable-line
})
export class InputSuffixDirective<T = any> {
  @Input() public inputSuffix;
  constructor(public templateRef: TemplateRef<T>) {}
}
